import { IkasProductOption, IkasProductOptionSelectSettings } from ".";
import _sortBy from "lodash/sortBy";

export function initIkasProductOption(option: IkasProductOption) {
  if (option.selectSettings)
    initProductOptionSelectSettings(option.selectSettings);
}

function initProductOptionSelectSettings(
  settings: IkasProductOptionSelectSettings
) {
  settings.values = _sortBy(settings.values || [], "order");
}
